// Centralized API URL configuration
// In production, REACT_APP_API_URL must be set — localhost fallback is dev-only
export const API_URL = process.env.REACT_APP_API_URL
  || (process.env.NODE_ENV === 'production' ? undefined : 'http://localhost:5000');

if (!API_URL && process.env.NODE_ENV === 'production') {
  console.error('FATAL: REACT_APP_API_URL is not set in production build');
}

// Confluence Cloud site the support knowledge lives on. stakedotcom.atlassian.net
// was frozen on 2026-08-05; the content (space SCS1) is on easygo-group. Page ids
// changed in the move, so never build a link to the old host.
export const CONFLUENCE_BASE_URL = 'https://easygo-group.atlassian.net';
